import { Controller } from 'stimulus'
import { DirectUpload } from "@rails/activestorage"
import Compressor from 'compressorjs'

export default class extends Controller {
  static targets = ['input', 'output', 'label', 'dropzone', 'spinner']

  connect() {
    const fileName = this.data.get('file')
    this.formTarget = this.inputTarget.closest('form')
    
    if (fileName) {
      this.updateLabelWithFile(fileName)
    }
  }

  clickUpload(event) {
    if (event.target === this.inputTarget) return
    this.inputTarget.click()
  }

  dragOver(event) {
    event.preventDefault()
    event.stopPropagation()
    this.dropzoneTarget.classList.add('dragover')
  }

  dragLeave(event) {
    event.preventDefault()
    event.stopPropagation()
    this.dropzoneTarget.classList.remove('dragover')
  }

  drop(event) {
    event.preventDefault()
    event.stopPropagation()
    this.dropzoneTarget.classList.remove('dragover')

    const files = event.dataTransfer.files
    if (files.length > 0) {
      this.inputTarget.files = files
      this.handleFiles()
    }
  }

  handleFiles() {
    const files = this.inputTarget.files

    if (files && files[0]) {
      const file = files[0]

      const acceptedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/webp', 'application/pdf']
      if (!acceptedTypes.includes(file.type)) {
        alert(I18n.t('purchase_invoices.invalid_file_type'))
        return
      }

      const isImage = file.type.startsWith('image/')
      
      if (isImage) {
        this.compressAndUpload(file)
      } else {
        this.uploadFile(file)
      }

      this.updateLabelWithFile(file.name)
    }
  }

  compressAndUpload(file) {
    new Compressor(file, {
      quality: 0.6,
      maxWidth: 1024,
      maxHeight: 1024,
      success: (result) => {
        const compressedFile = new File([result], file.name, {
          type: result.type,
          lastModified: Date.now()
        })
        
        this.uploadFile(compressedFile)
        this.previewFile(compressedFile)
      },
      error: (error) => {
        this.uploadFile(file)
        this.previewFile(file)
      }
    })
  }

  uploadFile(file) {
    const upload = new DirectUpload(file, '/rails/active_storage/direct_uploads', this)

    upload.create((error, blob) => {
      if (error) { 
        console.error("Upload error:", error)
      } else { this.previewFile(file) }
    })
  }

  previewFile(file) {
    if (this.hasOutputTarget) {
      const iframe = this.outputTarget
      iframe.style.display = 'block'
      iframe.src = window.URL.createObjectURL(file)
      iframe.height = this.data.get('height')
      iframe.width = this.data.get('width')
    }
  }

  uploadAndSubmit() {
    if (this.hasSpinnerTarget) {
      this.labelTarget.classList.add('d-none')
      this.spinnerTarget.classList.remove('d-none')
    }
    this.handleFiles()
    this.formTarget.requestSubmit()
  }

  updateLabelWithFile(filename) {
    this.labelTarget.innerHTML = `
      <i class="far fa-file-alt"></i>
      <div class="uploaded-file-name">${filename}</div>
      <small class="text-muted">${I18n.t('purchase_invoices.change_document')}</small>
    `
    if (this.hasDropzoneTarget) {
      this.dropzoneTarget.classList.add('has-file')
    }
  }
}
